/**
 * Lets the page read the state of the top-seller-lead mutation that
 * `RequestCallButton` fires, so the failure banner can sit at the top of the
 * page instead of next to the button.
 */
export const TOP_SELLER_LEAD_CACHE_KEY = 'lead-follow-up-top-seller-lead';

export const topSellersSliderBreakPoints = {
  1200: { slidesPerView: 5, spaceBetween: 16 },
  960: { slidesPerView: 4, spaceBetween: 16 },
  720: { slidesPerView: 3, spaceBetween: 16 },
  540: { slidesPerView: 2.5, spaceBetween: 12 },
  320: { slidesPerView: 1.8, spaceBetween: 12 },
};

export const relatedListingsSliderBreakPoints = {
  1200: { slidesPerView: 3, spaceBetween: 24 },
  960: { slidesPerView: 2.5, spaceBetween: 16 },
  720: { slidesPerView: 2, spaceBetween: 16 },
  540: { slidesPerView: 1.5, spaceBetween: 12 },
  320: { slidesPerView: 1.1, spaceBetween: 12 },
};
